import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.table.row.text,
  },
  '@global': {
    'td:first-of-type': {
      paddingLeft: '1rem',
    },
    'td:last-of-type': {
      paddingRight: 0,
    },
  },
}));

export default useStyles;
